import {MemberEntityModel} from "../../member-entity.model";
import {EditService} from "../../../../framework/entity/edit/edit-page/edit.service";
import {Component} from "@angular/core";

@Component({
    selector: "wbo-member-edit-pricing",
    templateUrl: "./member-edit-pricing.component.html"
})
export class MemberEditPricingComponent {
    constructor(public model: MemberEntityModel, public editService: EditService) {

    }
}
